module.exports = __webpack_public_path__ + "img/reverify-linkedin.cfa1a808.svg";